import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { getFullLanguageName } from "@faire/web--source/common/consts/THREE_TO_FULL_LANGUAGE_NAME";
import { getTwoLetterLanguageCode } from "@faire/web--source/common/consts/THREE_TO_TWO_LETTER_LANGUAGE_CODE";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { hasDuplicateLanguages, isLanguageDuplicatedInLocales } from "@faire/web--source/common/localization/languageOptions";
import { localeKeyToFullLanguageName } from "@faire/web--source/common/localization/localeKeyToFullLanguageName";
import { localeKeyToLocaleString } from "@faire/web--source/common/localization/localeKeyToLocaleString";
import { Global } from "@faire/web--source/slate/icons/foundation/Global";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { Language } from "@faire/web-api--source/indigofair/languages/Language";
import { useMemo } from "react";
import * as React from "react";
export var LanguageSelectorText = function(param) {
    var browserLocale = param.browserLocale, browserLanguage = param.browserLanguage, availableLocales = param.availableLocales, displayFullLanguageName = param.displayFullLanguageName;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var availableLocalesHasDuplicateLanguages = useMemo(function() {
        return hasDuplicateLanguages(availableLocales);
    }, [
        availableLocales
    ]);
    var renderSelectedText = function() {
        if (!availableLocalesHasDuplicateLanguages || browserLocale === undefined) {
            return displayFullLanguageName ? getFullLanguageName(browserLanguage) : getTwoLetterLanguageCode(browserLanguage);
        }
        if (browserLocale.language === Language.LANGUAGE_UNKNOWN) {
            return "";
        }
        var includeCountry = browserLocale && browserLocale.language && isLanguageDuplicatedInLocales(Language[browserLocale.language], availableLocales);
        return displayFullLanguageName ? localeKeyToFullLanguageName(browserLocale, includeCountry) : localeKeyToLocaleString({
            localeKey: browserLocale,
            includeCountry: includeCountry,
            lowercaseLanguage: false
        });
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Global, {
                titleAccess: strictLocalize({
                    id: "XyKx+G",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Languages"
                        }
                    ]
                }),
                fontSize: "16",
                color: Core.text.enabled
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                width: "1x"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                children: renderSelectedText()
            })
        ]
    });
};
